import Item from '../item';
import { ELIXIRS, ITEM_STATS } from '../item/item-types';
import { PageSubTitle } from '../menu/page-sub-title';

const PotionIndex: React.FC = () => {
    return (
        <div className='potion-index' id='potions'>
            <PageSubTitle
                label='Potions'
                name='potion-index'
                image='/resources/compendium/potion_seller_icon.png'
            />
            <div className='potion-index-content'>
                {ELIXIRS.map(item => {
                    const ingredientPotion = ITEM_STATS[item].components?.[0];

                    return ingredientPotion && (<div className='potion-index-entry'>
                        <Item key={ingredientPotion} itemName={ingredientPotion} />
                        <img height={60} width={40} src={`/resources/menu/menu_arrow.png`} alt='Arrow' />
                        <Item key={item} itemName={item} /></div>
                    )
                })}
            </div>
        </div>
    );
};

export default PotionIndex;